

<template>
    <v-layout>
        <v-navigation-drawer v-model="drawer" location="right" temporary :width="400"
            style="background: white; position: fixed; top: 71px;" class="side-menu">

            <v-card density="compact" flat class="mainCard pa-4 pt-0 ">
                <div class="pt-4 cardTitle">
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div class="title pl-3 pb-2">Received Reply</div>
                        <!-- <v-icon @click.stop="showFilter=!showFilter" v-if="!showFilter">mdi-magnify</v-icon>
                        <div style="display: flex;gap: 10px;padding-bottom: 5px;" v-else>
                        <TextFieldComponent 
                            density="compact"
                            dense @input="Searching"  :placeholder="search" v-model="searchText"
                            append-inner-icon="mdi-magnify" />
                        </div>                         -->
                    </div>
                    <div style="display: flex;gap: 10px;">
                        <AutoComplete :items="uniqueAccount" item-title="account_name" v-model="account_id" item-value="id"
                            placeholder="Account Name" @update:modelValue="getFilterData" />
                        <TextFieldComponent 
                        density="compact"
                        dense @input="Searching"  placeholder="Reference Number" v-model="searchText"
                        append-inner-icon="mdi-magnify" />
                    </div>
                </div>
                <SkeletenForReceivedReply v-if="loading === true " />
                <v-card-item  style="overflow: auto; width: 375px;" class="cardContents" v-else>
                    <div class="cardItem" v-for="user in users" :key="user.id" >
                        <!-- <div :class="item.action === 'clarification' ? 'cardItem1' : 'cardItem'"> -->
                            <div style="display: flex;gap: 10px;">
                                <div class="profile">
                                    <CustomAvatar2  :size="'medium'" 
                                    :fName="user.action_user_first_name" 
                                    :lName="user.action_user_last_name"
                                    :theme="getRandomColor()"  /> 
                                </div>
                                <div class="description">
                                    <!-- <div class="d-flex justify-end" >
                                        <div v-if="user.action == 'clarification'" class="notify"></div>
                                    </div> -->
                                    <v-tooltip v-if="!isMobileView" :text="user.issue_name.replace(/<\/?p>/g, '')" location="top" >
                                        <template #activator="{ props }">
                                        <span class="userName" v-bind="props">
                                            {{ getTrimmedText(user.issue_name.replace(/<\/?p>/g, '')) }}
                                            <div v-if="user.action == 'clarification'" class="notify"></div>
                                        </span>
                                        
                                        </template>
                                    </v-tooltip>
                                    <!-- {{ user.action }} -->
                                    <div class="received_time">
                                        <div class="issueChip" @click="sendToissue(user.issues_id)" v-if="user.reference_num">
                                        {{ user && user.reference_num ?
                                            user.reference_num : '' }}
                                        </div>
                                        <div class="response">
                                            <v-tooltip v-if="!isMobileView" text="Response Received" location="bottom" >
                                                <template #activator="{ props }">
                                                    <v-icon v-bind="props" v-on="on">
                                                        mdi-calendar
                                                    </v-icon>
                                                </template>
                                            </v-tooltip>
                                        <span class="ml-2">{{user.received_response != null ? formatDateEst(user.received_response) : '--' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- </div> -->
                    </div>
                    
                </v-card-item>
            </v-card>
        </v-navigation-drawer>
    </v-layout>
</template>

<script>
import AutoComplete from '@/components/ui/AutoComplete.vue';
import CustomAvatar2 from '@/components/ui/CustomAvatar2.vue';
import TextFieldComponent from '@/components/TextFieldComponent.vue';
import IssueService from '@/api/service/Issue/IssueService';
import WorkSpaceService from '@/api/service/WorkSpace/WorkSpaceService';
import dayjs from 'dayjs';
import SkeletenForReceivedReply from './SkeletenForReceivedReply.vue';
import ForumService from '@/api/service/Forum/ForumService';

export default {
    components: {
        AutoComplete,
        CustomAvatar2,
        TextFieldComponent,
        SkeletenForReceivedReply
    },
    data() {
        return {
            showInprogress:false,
            drawer: false,
            users: [],
            action_id: [],
            allUsers:[],
            showFilter:false,
            workTiming: [],
            workSpaces: [],
            backupUserData: null,
            account_id: [],
            searchText:null,
            loading:false,
            workSpace_ids:[],
            commentData:[],
            userData:{},
            checkViewofUser:[],

        }
    },
    created() {
        this.userData = JSON.parse(localStorage.getItem("user_details"));
    },

    computed: {
        uniqueAccount() {
            const seen = new Set();
            return this.allUsers.filter(item => {
            const val = item.account_name;
            if (seen.has(val)) return false;
            seen.add(val);
            return true;
            });
        },
  },



    methods: {
        getRandomColor() {
            const letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        getTrimmedText(text) {
            return text && text.length <= 35 ? text : text && text.slice(0, 35) + '...';
        },

        async Searching(event){
            let field = event.target.value
            let filtered = this.allUsers;

            if (field) {
                filtered = filtered.filter(item => {
                return (
                    (item.reference_num && item.reference_num.toLowerCase().includes(field))
                    );
                });
            }
            console.log(filtered, 'Filtered Data!!!');
            this.users = filtered;
        },

        formatDateEst(date) {
        return dayjs(date).format('MMM D, YYYY h:mm A')
        },

        async getUsers() {
            this.loading = true
            try {
                let work = await WorkSpaceService.getWorkSpaceByUser({active:1})
                // let workSpace_ids = []
                work.forEach((workSpace) => {
                  this.workSpace_ids.push(workSpace.id)
                })
                // await new Promise((resolve) => setTimeout(resolve, 10000));
                // console.log(this.workSpace_ids,"this.workSpace_ids")
                let res = await IssueService.getReceivedReplyData({account_id : this.workSpace_ids.join(',')})
                // console.log(res,"getReceivedReplyData!!")
                this.users = res && res.length > 0 ? res : []
                this.action_id = this.users.map(data => data.issues_id)
                this.action_id.join(',')
                // for (let user of this.users) {
                //     this.action_id += user.issues_id
                //     
                //     // console.log(user, "forums!!!!");
                //     // let forums = await ForumService.getAction({key_id:user.issues_id})
                //     // console.log(forums,"forumssss")
                //     // user.action = forums[0].action
                //     // console.log(this.users,"user")
                // }             
                if(this.action_id.length > 0){
                    let forums = await ForumService.getNotify({key_id:this.action_id.join(',')})
                   
                    const result = this.users.map(issue => {
                        const matchedForum = forums.find(key => key.key_id === issue.issues_id);
                        return {
                            ...issue,
                            action: matchedForum ? matchedForum.action : ''
                        };
                    });

                    this.users = result
                }
                this.allUsers = res && res.length > 0 ? res : []
                this.backupUserData = JSON.parse(JSON.stringify(this.users))

                this.loading = false
            }
            catch (e) {
                console.log(e)
            }
        },

        async getForumData(id) {
            try {
                let res = await ForumService.getAction({
                key_id: id,
                });
                console.log(res,'getForumList')
                
                this.commentData = res;
                console.log(this.commentData,"this.commentData")
                let $type = "viewreceivedreply"
                this.checkViewofUser = this.commentData.filter((item) => {
                    return (
                    item.action &&
                    item.action.toLowerCase() == $type.toLowerCase()
                    // item.created_by == this.userData.id
                    );
                }
            );
            console.log(this.checkViewofUser,' $filter ')
            return this.checkViewofUser;
            } catch (e) {
                this.commentData = [];
            }
        },

        async sendToissue(id){
            await this.getForumData(id)
            // console.log(id,"id!!!@@@")
            this.$store.dispatch('setIssueInView',id)
            // console.log(this.checkViewofUser,"sendToissue")
            if(this.checkViewofUser.length == 0){
                // alert(2)
                let data = {
                key_type: "issue",
                key_id: id,
                action: 'viewReceivedReply',
                description: `${this.userData.username} viewed the issue `,
                };
                // console.log(data);
                let $response = await ForumService.create(data);
                console.log($response,"ForumService")
                this.getUsers()

            } else {
                console.log('already inserted')
            }
        },
 

        async getFilterData() {
            let filtered = this.allUsers;
            console.log(this.account_id,'iiii!!!')
            if (this.account_id.length > 0) {
                console.log(this.account_id,'stage!!')
                filtered = filtered.filter(item => this.account_id.includes(item.account_name));
            }
            console.log(filtered, 'Filtered Data!!!');
            this.users = filtered;
            },
        }


    }


</script>

<style scoped>
>>>.v-navigation-drawer__scrim {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 117vh;
    background: black;
    opacity: 0.2;
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
}
>>>.v-selection-control {
    align-items: center;
    contain: layout;
    display: flex;
    flex: 1 0;
    grid-area: control;
    gap: 10px;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    flex-direction: row-reverse;
}
>>>.v-navigation-drawer__content {
    flex: 0 1 auto;
    height: 93vh;
    padding-bottom: 12px;
    /* overflow: hidden; */
}

>>> .v-input__details {
    padding-inline-start: 16px;
    padding-inline-end: 16px;
    display: contents;
}
.mainCard {
    width: fit-content;
    overflow: hidden;
    text-wrap: nowrap;
}

.cardTitle {
    position: fixed;
    top: 0px;
    background-color: rgb(255, 255, 255);
    z-index: 999;
    right: 0px;
    width: 100%;
    padding: 0 19px;
    padding-bottom: 8px;
}

.cardContents {
    overflow: auto;
    position: relative;
    top: 122px;
    margin-bottom: 120px;
    padding: 4px 4px;
}

.title {
    color: #000;
    font-size: 18px;
    font-weight: 700;
}
.cardItem1{
    background-color: #ed0f0f45;
}
.notify{
    background: red;
    width: 10px;
    height: 10px;
    border-radius: 50%;
}
.cardItem:nth-child(odd) {
    background: #edf5ff;
}

.cardItem:nth-child(even) {
    background: #e0e0e0;
}

.cardItem {
    display: flex;
    flex-direction: column;
    gap: 10px;
    /* justify-content: space-between; */
    padding: 10px 10px;
    border-radius: 4px;
    margin-bottom: 8px;
}
.profile{
    display: flex;
    justify-content: center;
    align-items: center;
}
.description{
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.userName {
    color: #000;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* display: flex;
    align-items: center; */
    text-wrap: wrap;
}
.response{
    color: #000;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    gap: 5px;
    align-items: center;
    text-wrap: wrap;
}

.chip {
    width: fit-content;
    height: fit-content;
    padding: 2px 5px;
    border-radius: 4px;
    border: 1px solid #FFCF53;
    background: #FEF0CC;
    color: #000;
    font-size: 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
}
.issueChip {
    width: fit-content;
    height: fit-content;
    padding: 2px 5px;
    border-radius: 4px;
    border: 1px solid #000;
    background: #fff;
    color: #000;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.received_time{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.status {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    color: #fff
}
</style>